import React, { useState, useEffect } from 'react';
import api from '../api/client';

const S = {
  wrap: { maxWidth: 680, margin: '0 auto', fontFamily: 'inherit' },
  header: { background: '#2d4a8a', color: '#fff', padding: '12px 20px', display: 'flex', alignItems: 'center', justifyContent: 'space-between' },
  subHeader: { background: '#3a5ba0', color: '#fff', padding: '8px 20px', fontSize: 14, fontWeight: 500 },
  body: { background: '#f0f2f5', minHeight: '100vh' },
  card: { background: '#fff', border: '1px solid #d0d8e8', borderRadius: 12, margin: 16, padding: 20 },
  cardTitle: { fontSize: 16, fontWeight: 600, color: '#2d4a8a', marginBottom: 16 },
  label: { fontSize: 13, color: '#666', marginBottom: 6, display: 'block' },
  required: { color: '#e24b4a', marginLeft: 2 },
  select: { width: '100%', padding: '10px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, marginBottom: 14, background: '#fff' },
  textarea: { width: '100%', minHeight: 110, padding: '10px 12px', border: '1px solid #d0d8e8', borderRadius: 8, fontSize: 14, resize: 'vertical', marginBottom: 14, boxSizing: 'border-box' },
  tagWrap: { display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 16 },
  tag: { padding: '6px 14px', borderRadius: 99, border: '1px solid #d0d8e8', fontSize: 13, cursor: 'pointer', color: '#666', background: '#fff' },
  tagOn: { padding: '6px 14px', borderRadius: 99, border: '1px solid #2d4a8a', fontSize: 13, cursor: 'pointer', color: '#fff', background: '#2d4a8a' },
  sendBtn: { width: '100%', padding: 13, background: '#2d4a8a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 500, cursor: 'pointer', marginBottom: 10 },
  sendBtnDisabled: { width: '100%', padding: 13, background: '#aaa', color: '#fff', border: 'none', borderRadius: 8, fontSize: 15, cursor: 'not-allowed', marginBottom: 10 },
  hintBtn: { width: '100%', padding: 11, background: '#eef2fa', color: '#2d4a8a', border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer' },
  tabs: { display: 'flex', padding: '12px 16px 0', borderBottom: '1px solid #e0e4ec', background: '#fff', overflowX: 'auto' },
  tabBtn: { padding: '7px 16px', fontSize: 13, cursor: 'pointer', color: '#888', background: 'transparent', border: 'none', borderBottom: '2px solid transparent', whiteSpace: 'nowrap' },
  tabBtnActive: { padding: '7px 16px', fontSize: 13, cursor: 'pointer', color: '#2d4a8a', fontWeight: 500, background: 'transparent', border: 'none', borderBottom: '2px solid #2d4a8a', whiteSpace: 'nowrap' },
  chatArea: { padding: 16 },
  dateSep: { textAlign: 'center', fontSize: 12, color: '#999', margin: '16px 0 12px' },
  studentRow: { display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 16 },
  studentBubble: { background: '#fff', border: '1px solid #d0d8e8', borderRadius: '0 12px 12px 12px', padding: '12px 14px', maxWidth: '85%', fontSize: 13 },
  aiRow: { display: 'flex', alignItems: 'flex-start', gap: 10, marginBottom: 8, flexDirection: 'row-reverse' },
  aiBubble: { background: '#2d4a8a', color: '#fff', borderRadius: '12px 0 12px 12px', padding: '12px 14px', maxWidth: '80%', fontSize: 13, lineHeight: 1.6 },
  aiBubbleError: { background: '#e24b4a', color: '#fff', borderRadius: '12px 0 12px 12px', padding: '12px 14px', maxWidth: '80%', fontSize: 13 },
  aiBubbleLoading: { background: '#ccc', color: '#fff', borderRadius: '12px 0 12px 12px', padding: '12px 14px', maxWidth: '80%', fontSize: 13 },
  avatar: { width: 36, height: 36, borderRadius: '50%', background: '#eef2fa', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 },
  aiAvatar: { width: 36, height: 36, borderRadius: '50%', background: '#2d4a8a', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 18, flexShrink: 0 },
  chatTime: { fontSize: 11, color: '#aaa', marginTop: 4, paddingLeft: 46 },
  subjectLabel: { fontSize: 12, fontWeight: 600, color: '#2d4a8a', marginBottom: 4 },
  targetText: { fontSize: 12, color: '#888', marginBottom: 8, lineHeight: 1.5 },
  chatText: { fontSize: 14, color: '#333', marginBottom: 8 },
  chatTags: { display: 'flex', gap: 6, flexWrap: 'wrap' },
  chatTag: { padding: '3px 10px', borderRadius: 99, border: '1px solid #d0d8e8', fontSize: 11, color: '#888' },
  logoutBtn: { fontSize: 12, padding: '5px 12px', border: '1px solid rgba(255,255,255,0.5)', borderRadius: 6, cursor: 'pointer', background: 'transparent', color: '#fff' },
  unitTargetBox: { background: '#f5f7fb', borderLeft: '3px solid #2d4a8a', padding: '8px 12px', fontSize: 12, color: '#555', marginBottom: 14, lineHeight: 1.5 },
  errorMsg: { color: '#e24b4a', fontSize: 13, textAlign: 'center', padding: '8px', background: '#fff5f5', borderRadius: 6, marginBottom: 10 }
};

const TAGS = ['理解できた','難しかった','面白かった','もっと学びたい','疑問が残る','達成感がある'];

const HINTS_COMMON = [
  { icon: '💡', title: 'きょうわかったこと', body: '「〇〇がわかった」「〇〇を初めて知った」という発見を書いてみよう！' },
  { icon: '🔍', title: 'どうやって考えた？', body: '答えにたどり着くまでに、どんな順番で考えましたか？その道すじを書いてみよう。' },
  { icon: '🤔', title: 'むずかしかったこと', body: '「〇〇がむずかしかった」だけでなく、「どこがむずかしかったか」も書くともっとよくなるよ！' },
  { icon: '🔗', title: 'まえに習ったこととつながった？', body: '前の授業や別の教科で習ったことと、今日の学習がつながっていると感じた場面はありましたか？' },
  { icon: '🌱', title: 'これからやってみたいこと', body: '「次はこんなことをやってみたい」「もっと〇〇を調べてみたい」という気持ちを書いてみよう！' },
  { icon: '💬', title: 'だれかに伝えるなら？', body: '今日学んだことを、家族や友だちに説明するとしたら、どんなふうに伝える？' },
];

const HINTS_BY_SUBJECT = {
  '国語':  [
    { icon: '📖', title: '登場人物の気もち', body: '主人公はどんな気もちでしたか？文章の中の言葉を手がかりに考えてみよう。' },
    { icon: '✏️', title: '表現のくふう', body: 'どんな言葉や表現が印象に残りましたか？なぜ作者はその言葉を選んだと思う？' },
  ],
  '算数':  [
    { icon: '🔢', title: 'どんな方法で解いた？', body: 'どの公式や考え方を使いましたか？なぜその方法を選びましたか？' },
    { icon: '📐', title: '図や表を使った？', body: '図や表に表すと、どんなことがわかりやすくなりましたか？' },
  ],
  '数学':  [
    { icon: '📊', title: 'どんな方法で解いた？', body: '公式や定理をどのように使いましたか？別の解き方はありましたか？' },
    { icon: '🔄', title: '日常生活とのつながり', body: '今日学んだことは、日常生活のどんな場面で使えそうですか？' },
  ],
  '理科':  [
    { icon: '🔬', title: '実験・観察でわかったこと', body: '実験や観察を通して、予想と比べてどんな違いがありましたか？' },
    { icon: '🌿', title: 'なぜそうなるの？', body: 'なぜその結果になったのか、理由を考えて書いてみよう。' },
  ],
  '社会':  [
    { icon: '🗺️', title: 'くらしとのつながり', body: '学んだことは、自分たちのくらしとどのようにつながっていますか？' },
    { icon: '👥', title: 'いろんな人の立場', body: '学んだできごとを、いろんな人の立場から考えるとどう見えますか？' },
  ],
  '英語':  [
    { icon: '🗣️', title: '使えそうな表現', body: '今日学んだ英語の表現を、どんな場面で使ってみたいですか？' },
    { icon: '🌍', title: '外国の文化', body: '英語を通して、外国の文化や考え方で気づいたことはありましたか？' },
  ],
  '外国語': [
    { icon: '🗣️', title: '使えそうな表現', body: '今日学んだ表現を、どんな場面で使ってみたいですか？' },
    { icon: '🌍', title: '外国の文化', body: '外国の文化や考え方で、気づいたことや驚いたことはありましたか？' },
  ],
  '音楽':  [
    { icon: '🎵', title: 'きこえた？感じた？', body: 'どんな音やリズムが印象に残りましたか？どんな気もちになりましたか？' },
    { icon: '🎼', title: '演奏・表現のくふう', body: '上手に演奏・表現するために、どんなことを意識しましたか？' },
  ],
  '図工':  [
    { icon: '🎨', title: 'つくるときのくふう', body: '作品をつくるとき、どんな工夫をしましたか？どこにこだわりましたか？' },
    { icon: '👀', title: '友だちの作品から学んだこと', body: 'ほかの人の作品を見て、気づいたことや参考にしたいことはありましたか？' },
  ],
  '体育':  [
    { icon: '🏃', title: '体の使い方', body: '動きのコツや体の使い方で、気づいたことはありましたか？' },
    { icon: '🤝', title: 'チームで学んだこと', body: 'チームやグループで活動して、気づいたことや大切だと思ったことは？' },
  ],
  '保健体育': [
    { icon: '💪', title: '体の使い方・動きのコツ', body: '動きのポイントで気づいたことや、改善できたことはありましたか？' },
    { icon: '🏥', title: '健康・安全について', body: '自分の健康や安全のために、学んだことをどう生かしますか？' },
  ],
  '道徳':  [
    { icon: '❤️', title: '自分だったら？', body: '今日の授業のテーマについて、自分だったらどうするか考えてみよう。' },
    { icon: '🌟', title: '大切にしたい気もち', body: '今日の学習で、これから大切にしていきたいと思ったことは何ですか？' },
  ],
  '自立活動': [
    { icon: '🌱', title: 'できるようになったこと', body: '今日の活動で、できるようになったことや、うまくいったことを書いてみよう。' },
    { icon: '💪', title: 'がんばったこと', body: '難しかったけどがんばったこと、次にもう一度チャレンジしたいことは何ですか？' },
  ],
};

function formatDate(d) {
  const dt = new Date(d);
  return `${dt.getFullYear()}/${String(dt.getMonth()+1).padStart(2,'0')}/${String(dt.getDate()).padStart(2,'0')}`;
}
function formatTime(d) {
  const dt = new Date(d);
  return `${String(dt.getHours()).padStart(2,'0')}:${String(dt.getMinutes()).padStart(2,'0')}`;
}

export default function StudentPage() {
  const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
  const [subjects, setSubjects] = useState([]);
  const [history, setHistory] = useState([]);
  const [subjectId, setSubjectId] = useState('');
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSubjectName, setSelectedSubjectName] = useState('');
  const [selectedGoalId, setSelectedGoalId] = useState('');
  const [text, setText] = useState('');
  const [tags, setTags] = useState([]);
  const [activeTab, setActiveTab] = useState('all');
  const [loading, setLoading] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');
  const [showHint, setShowHint] = useState(false);

  useEffect(() => {
    fetchSubjects();
    fetchHistory();
  }, []);

  const fetchSubjects = async () => {
    try {
      const grade = JSON.parse(localStorage.getItem('userInfo') || '{}').grade;
      const res = await api.get('/subjects' + (grade ? `?grade=${grade}` : ''));
      setSubjects(res.data);
    } catch (e) { console.error(e); }
  };

  const fetchHistory = async () => {
    setLoading(true);
    try {
      const res = await api.get('/reviews/mine');
      setHistory(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const onSubjectChange = (id) => {
    setSubjectId(id);
    setSelectedSubject(subjects.find(s => String(s.id) === String(id)) || null);
  };

  const toggleTag = (t) => setTags(prev => prev.includes(t) ? prev.filter(x=>x!==t) : [...prev,t]);

  const submit = async () => {
    if (!subjectId || !text.trim()) { setError('教科とふりかえりを入力してください'); return; }
    setError('');
    setSubmitting(true);
    try {
      const res = await api.post('/reviews', {
        subject_id: parseInt(subjectId),
        goal_id: selectedGoalId ? parseInt(selectedGoalId) : null,
        content: text,
        emotion_tags: tags
      });
      setHistory(prev => [res.data, ...prev]);
      setText(''); setTags([]); setSubjectId(''); setSelectedSubject(null); setSelectedSubjectName(''); setSelectedGoalId('');
    } catch (e) {
      setError(e.response?.data?.error || '送信に失敗しました');
    } finally {
      setSubmitting(false);
    }
  };

  // 教科名でグループ化したタブ
  const subjectNameTabs = [...new Set(
    subjects.filter(s => history.some(h => h.subject_id === s.id)).map(s => s.subject_name)
  )];
  const filtered = activeTab === 'all' ? history : history.filter(r => {
    const s = subjects.find(s => s.id === r.subject_id);
    return s && s.subject_name === activeTab;
  });

  const logout = () => {
    const isDemo = userInfo.school_code === 'DEMO01';
    localStorage.clear();
    window.location.href = isDemo ? '/demo' : '/login';
  };
  const backToTeacher = () => {
    // 体験版：教師画面に戻る（demo-teacherで再ログイン）
    fetch('/api/auth/teacher/login', { method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ login_id: 'demo-teacher', password: 'password' }) })
      .then(r => r.json()).then(data => {
        localStorage.setItem('token', data.token);
        localStorage.setItem('role', 'teacher');
        localStorage.setItem('userInfo', JSON.stringify(data));
        window.location.href = '/teacher';
      });
  };

  const displayName = `${userInfo.grade || ''}年${userInfo.class_name || ''} ${userInfo.number || ''}番`;

  return (
    <div style={S.wrap}>
      <div style={S.header}>
        <div style={{fontSize:13}}>{displayName}</div>
        <div style={{fontSize:15,fontWeight:600}}>自分の学びをふり返るアプリ</div>
        {userInfo.school_code === 'DEMO01' ? (
          <button style={{ ...S.logoutBtn, background: 'rgba(255,220,0,0.3)', borderColor: '#ffd700' }} onClick={backToTeacher}>← 教師画面に戻る</button>
        ) : (
          <button style={S.logoutBtn} onClick={logout}>ログアウト</button>
        )}
      </div>
      <div style={S.subHeader}>{displayName}さんのふり返り</div>
      <div style={S.body}>
        <div style={S.card}>
          <div style={S.cardTitle}>新しいふり返りを入力</div>
          {error && <div style={S.errorMsg}>{error}</div>}
          <label style={S.label}>教科<span style={S.required}>※</span></label>
          <select style={S.select} value={selectedSubjectName} onChange={e=>{ setSelectedSubjectName(e.target.value); setSubjectId(''); setSelectedSubject(null); }}>
            <option value="">選択してください</option>
            {[...new Set(subjects.map(s=>s.subject_name))].map(name=><option key={name} value={name}>{name}</option>)}
          </select>
          {selectedSubjectName && (() => {
            const units = subjects.filter(s=>s.subject_name===selectedSubjectName && s.unit_name && !s.is_completed);
            if (units.length === 0) {
              const s = subjects.find(s=>s.subject_name===selectedSubjectName && !s.is_completed);
              if (s && subjectId !== String(s.id)) { setTimeout(()=>onSubjectChange(String(s.id)),0); }
              return null;
            }
            return (
              <>
                <label style={{...S.label, marginTop:8}}>単元<span style={S.required}>※</span></label>
                <select style={S.select} value={subjectId} onChange={e=>onSubjectChange(e.target.value)}>
                  <option value="">単元を選択してください</option>
                  {units.map(s=><option key={s.id} value={s.id}>{s.unit_name}</option>)}
                </select>
              </>
            );
          })()}
          {selectedSubject && selectedSubject.goals && selectedSubject.goals.length > 0 && (
            <>
              <label style={{...S.label, marginTop:8}}>目標<span style={{fontSize:11,color:'#9ca3af',marginLeft:4}}>（省略可）</span></label>
              <select style={S.select} value={selectedGoalId} onChange={e=>setSelectedGoalId(e.target.value)}>
                <option value="">目標を選択（省略可）</option>
                {selectedSubject.goals.map(g=><option key={g.id} value={g.id}>{g.goal_text}</option>)}
              </select>
            </>
          )}
          {!selectedSubject?.goals?.length && selectedSubject?.unit_target && (
            <div style={S.unitTargetBox}>単元目標：{selectedSubject.unit_target}</div>
          )}
          <label style={S.label}>ふり返り<span style={S.required}>※</span></label>
          <textarea style={S.textarea} placeholder="授業のふり返りを入力" value={text} onChange={e=>setText(e.target.value)} maxLength={400} />
          <div style={{fontSize:12,color:'#aaa',textAlign:'right',marginTop:-10,marginBottom:10}}>{text.length}/400</div>
          <label style={S.label}>感情タグ</label>
          <div style={S.tagWrap}>
            {TAGS.map(t=><span key={t} style={tags.includes(t)?S.tagOn:S.tag} onClick={()=>toggleTag(t)}>{t}</span>)}
          </div>
          <button style={submitting?S.sendBtnDisabled:S.sendBtn} onClick={submit} disabled={submitting}>
            {submitting ? 'AIコメント生成中...' : '送信'}
          </button>
          <button style={S.hintBtn} onClick={() => setShowHint(true)}>ふり返りのヒントを見る 💡</button>

        {showHint && (
          <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.45)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', zIndex: 1000, overflowY: 'auto', padding: '20px 16px' }}>
            <div style={{ background: '#fff', borderRadius: 16, width: '100%', maxWidth: 480, padding: 24, marginTop: 20 }}>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 16 }}>
                <div style={{ fontSize: 16, fontWeight: 600, color: '#2d4a8a' }}>💡 ふり返りのヒント</div>
                <button style={{ border: 'none', background: 'none', fontSize: 20, cursor: 'pointer', color: '#aaa' }} onClick={() => setShowHint(false)}>✕</button>
              </div>
              <div style={{ fontSize: 13, color: '#888', marginBottom: 16, background: '#f5f7fb', padding: '8px 12px', borderRadius: 8 }}>
                下のヒントを参考に、自分の言葉でふり返りを書いてみよう！
              </div>
              {selectedSubject && HINTS_BY_SUBJECT[selectedSubject.subject_name] && (
                <div style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#2d4a8a', marginBottom: 8 }}>📚 {selectedSubject.subject_name}のヒント</div>
                  {HINTS_BY_SUBJECT[selectedSubject.subject_name].map((h, i) => (
                    <div key={i} style={{ background: '#e6f1fb', borderRadius: 10, padding: '10px 14px', marginBottom: 8 }}>
                      <div style={{ fontSize: 13, fontWeight: 600, color: '#0c447c', marginBottom: 4 }}>{h.icon} {h.title}</div>
                      <div style={{ fontSize: 13, color: '#185fa5', lineHeight: 1.6 }}>{h.body}</div>
                    </div>
                  ))}
                </div>
              )}
              <div>
                <div style={{ fontSize: 12, fontWeight: 600, color: '#555', marginBottom: 8 }}>✨ どんな教科にも使えるヒント</div>
                {HINTS_COMMON.map((h, i) => (
                  <div key={i} style={{ background: '#f5f7fb', borderRadius: 10, padding: '10px 14px', marginBottom: 8 }}>
                    <div style={{ fontSize: 13, fontWeight: 600, color: '#333', marginBottom: 4 }}>{h.icon} {h.title}</div>
                    <div style={{ fontSize: 13, color: '#666', lineHeight: 1.6 }}>{h.body}</div>
                  </div>
                ))}
              </div>
              <button style={{ width: '100%', padding: 12, background: '#2d4a8a', color: '#fff', border: 'none', borderRadius: 8, fontSize: 14, fontWeight: 500, cursor: 'pointer', marginTop: 8 }} onClick={() => setShowHint(false)}>
                とじる
              </button>
            </div>
          </div>
        )}
        </div>

        <div style={{background:'#fff'}}>
          <div style={S.tabs}>
            <button style={activeTab==='all'?S.tabBtnActive:S.tabBtn} onClick={()=>setActiveTab('all')}>すべて</button>
            {subjectNameTabs.map(name=>(
              <button key={name} style={activeTab===name?S.tabBtnActive:S.tabBtn} onClick={()=>setActiveTab(name)}>{name}</button>
            ))}
          </div>
        </div>

        <div style={S.chatArea}>
          {loading && <div style={{textAlign:'center',color:'#aaa',padding:20}}>読み込み中...</div>}
          {filtered.map((item, idx) => {
            const date = formatDate(item.created_at);
            const prevDate = idx > 0 ? formatDate(filtered[idx-1].created_at) : null;
            return (
              <div key={item.id}>
                {(idx===0 || prevDate!==date) && <div style={S.dateSep}>{date}</div>}
                <div style={S.studentRow}>
                  <div style={S.avatar}>🎒</div>
                  <div>
                    <div style={S.studentBubble}>
                      <div style={S.subjectLabel}>{item.subject_name}</div>
                      {item.unit_target && <div style={S.targetText}>目標：{item.unit_target}</div>}
                      <div style={S.chatText}>{item.content}</div>
                      {item.emotion_tags?.length > 0 && (
                        <div style={S.chatTags}>{item.emotion_tags.map(t=><span key={t} style={S.chatTag}>{t}</span>)}</div>
                      )}
                    </div>
                    <div style={S.chatTime}>{formatTime(item.created_at)}</div>
                  </div>
                </div>
                {item.ai_comment ? (
                  <div style={S.aiRow}>
                    <div style={S.aiAvatar}>🤖</div>
                    <div style={S.aiBubble}>{item.ai_comment}</div>
                  </div>
                ) : (
                  <div style={S.aiRow}>
                    <div style={S.aiAvatar}>🤖</div>
                    <div style={S.aiBubbleError}>AIコメントの生成中にエラーが起きました。</div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}
